import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const Timer = ({
  setShowTimer,
  ttl,
}: {
  setShowTimer: (bool: boolean) => void;
  ttl: number;
}) => {
  const { t } = useTranslation("clientView");
  const [remain, setRemain] = useState(ttl);

  useEffect(() => {
    const interval = setInterval(() => {
      setRemain(remain - 1);

      if (remain <= 0) setShowTimer(false);
    }, 1000);

    return () => clearInterval(interval);
  }, [remain, setShowTimer, ttl]);

  return <span>{t("common.secondsCount", { count: remain })}</span>;
};
